import React from "react";
import "../../styles/projectStyles/ProjectCard.css";
import { useNavigate } from "react-router-dom";

const ProjectCard = ({ project }) => {
  const navigate = useNavigate();

  const handleProjectDetailsClick = (id) => {
    navigate(`/projectdetails/${id}`);
  };

  return (
    <div className="card project-card">
      <div className="card-header">
        <span className="date-range">{project.timeFrame || "No timeframe available"} </span>
        <span className={`status ${project.status.toLowerCase().replace(" ", "-")}`} >
          <img src="/images/progress.png" alt={project.status} className="status-icon"/>
          {project.status}
        </span>
      </div>

      <div className="card-body">
        <h3 className="address">{project.address}</h3>
        <p className="time">9:00 am - 10:00 am</p>
        <p className="tasks">Assigned Tasks:</p>
        <p className="task-list">
          {project.tasks.map((task, index) => (
            <div key={index} className="task-item">
            <p>{task.taskName}</p>
          </div>
          ))}
        </p>

      </div>

      <div className="card-footer">
        <p className="contact"> 
            <span className="worker-avatar">
            <img src="/images/users.svg" className="avatar-image"/>
            </span> {project.contact}
        </p>

        <button className="arrow-btn" onClick={() => handleProjectDetailsClick(project.projectId)}>
          <img src="/images/arrow.png" alt="Arrow" className="arrow-icon" />
        </button>
      </div>
    </div>
  );
};

export default ProjectCard;
